<template>
    <aside :class="['sidebar', {'mobile-hide': !hideDefaultContent}]">
        <div :class="['sidebar__container', { 'is-show': isShowSidebar }]">
            <div class="sidebar__button-close">
                <STBaseButton icon-after="IconCloseSmall"
                              icon-after-modify="icon-stroke icon_color_label"
                              modify="button_theme_reset button_close button_laptop_hide"
                              @click="toggleSidebar" />
            </div>

            <ContentDefault v-if="!hideDefaultContent"
                            @openCallbackPopup="_showCallbackForm"
                            @closCallbackPopup="_hideCallbackForm"
                            @openUniqueCheckPopup="_showUniqueCheckForm"
                            @closeUniqueCheckPopup="_hideUniqueCheckForm"
                            @openBrokerTourPopup="_showRequestBrokerTourForm"
                            @toggleSidebar="toggleSidebar" />

            <NewsList v-if="sidebarNews && Object.keys(sidebarNews).length && !hideSidebarNews"
                      :news="sidebarNews" />

            <slot />
        </div>

        <STBaseButton v-if="isCustomButtonText && buttonText"
                      :text="buttonText"
                      modify="sidebar__toggle-custom button_laptop_hide"
                      @click="toggleSidebar" />

        <STBaseButton v-else-if="!isCustomButtonText"
                      icon-before="IconAlertOutlineWhite"
                      modify="button_theme_reset button_theme_question button_laptop_hide"
                      @click="toggleSidebar" />

        <transition name="fade">
            <div v-if="isShowSidebar"
                 class="sidebar__overlay"
                 @click="toggleSidebar" />
        </transition>
    </aside>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import ContentDefault from './Content/Default';
import NewsList from './Content/NewsList';

export default {
    name: 'TheSidebar',

    inject: [
        'showCallbackForm',
        'hideCallbackForm',
        'showUniqueCheckForm',
        'hideUniqueCheckForm',
        'showRequestBrokerTourForm',
        'hideRequestBrokerTourForm'
    ],

    components: {
        ContentDefault,
        NewsList
    },

    props: {
        hideDefaultContent: {
            type   : Boolean,
            default: false
        },
        hideSidebarNews: {
            type   : Boolean,
            default: false
        },
        isCustomButtonText: Boolean,
        buttonText        : String
    },

    data() {
        return {
            isShowSidebar: false,
            bodyDom      : null
        };
    },

    computed: {
        ...mapGetters({
            sidebarNews    : 'GET_SIDEBAR_NEWS',
            isAuthenticated: 'GET_IS_AUTHENTICATED'
        })  
    },

    mounted() {
        this.bodyDom = document.querySelector('body');

        if (!this.sidebarNews && this.isAuthenticated) {
            this.getSidebarNewsData();
        }
    },

    methods: {
        ...mapActions(['getSidebarNewsData']),

        toggleSidebar() {
            this.isShowSidebar = !this.isShowSidebar;

            if (this.isShowSidebar) {
                this.scrollY = window.pageYOffset;
                this.bodyDom.style.maxHeight = '100vh';
                this.bodyDom.scrollTo(0, this.scrollY);
            } else {
                this.bodyDom.style.maxHeight = 'none';

                window.scrollTo({
                    top     : this.scrollY,
                    left    : 0,
                    behavior: 'instant'
                });
            }
        },

        _showCallbackForm() {
            this.showCallbackForm();
        },

        _hideCallbackForm() {
            this.hideCallbackForm();
        },

        _showUniqueCheckForm() {
            this.showUniqueCheckForm();
        },

        _hideUniqueCheckForm() {
            this.hideUniqueCheckForm();
        },

        _showRequestBrokerTourForm() {
            this.showRequestBrokerTourForm();
        },

        _hideRequestBrokerTourForm() {
            this.hideRequestBrokerTourForm();
        }
    },
};
</script>

<style lang="scss">
@import "Sidebar";
</style>
